import axios from 'axios';

export default class SBPZip {

  constructor (name = `emarf-sbp`) {
    this.name = name;
    this.urls = [];
  }

  add (url) {
    this.urls.push(url);
  }

  get (url) {
    return axios.get(
      url,
      {
        responseType: 'blob'
      })
      .then(response => {
        return new Blob([response.data], {
          type: response.data.type
        });
      });
  }

  download () {
    this.urls.forEach(url => {
      // CAUTION:
      // hrefにzip urlを指定した場合、download属性に設定された名前をzipファイルにつけることができない
      // zipファイルに名前を設定するにはzipデータをblob化してURL.createObjectURLで再度URLを生成する必要がある
      this.get(url).then((blob) => {
        const link = document.createElement('a');
        const href = URL.createObjectURL(blob);
        link.setAttribute('download', `${this.name}.zip`);
        link.setAttribute('href', href);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/sbp/SBPZip.js